var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Orders", path: { name: "admin-orders" } }],
          name: _vm.orderName,
          "no-title": "",
        },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "3", md: "6" } },
                [
                  _c("b-card", { staticClass: "admin-order-card" }, [
                    _c("div", { staticClass: "admin-order-card-label" }, [
                      _vm._v("Seller:"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-order-card-title" }, [
                      _vm._v(_vm._s(_vm.order.seller_license.facility.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-order-card-label mt-2" }, [
                      _vm._v("License:"),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.order.seller_license.number)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-2" }, [
                      _c("div", { staticClass: "admin-order-card-label" }, [
                        _vm._v("Pickup Address:"),
                      ]),
                      _vm._v(" "),
                      _vm.sellerLicenseAddress.first
                        ? _c("div", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.sellerLicenseAddress.first) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sellerLicenseAddress.second
                        ? _c("div", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.sellerLicenseAddress.second) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-order-card-label mt-2" }, [
                      _vm._v("Sales Rep:"),
                    ]),
                    _vm._v(" "),
                    _vm.order.seller_user
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.order.seller_user.full_name)),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "4", md: "6" } },
                [
                  _c("b-card", { staticClass: "admin-order-card" }, [
                    _c("div", { staticClass: "admin-order-card-label" }, [
                      _vm._v("Buyer:"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-order-card-title" }, [
                      _vm._v(_vm._s(_vm.order.buyer_license.facility.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-order-card-label mt-2" }, [
                      _vm._v("License:"),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.order.buyer_license.number))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "my-2" }, [
                      _c("div", { staticClass: "admin-order-card-label" }, [
                        _vm._v("Delivery Address:"),
                      ]),
                      _vm._v(" "),
                      _vm.buyerLicenseAddress.first
                        ? _c("div", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.buyerLicenseAddress.first) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.buyerLicenseAddress.second
                        ? _c("div", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.buyerLicenseAddress.second) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row q-col-gutter-sm" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "admin-order-card-label" }, [
                          _vm._v("Point of Contact:"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.order.buyer_user
                                ? _vm.order.buyer_user.full_name
                                : ""
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.order.buyer_user.phone
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-black",
                                  attrs: { href: `${_vm.buyerPhoneLink}` },
                                },
                                [_vm._v(_vm._s(_vm.order.buyer_user.phone))]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "a",
                            {
                              staticClass: "text-black",
                              attrs: { href: _vm.buyerEmailLink },
                            },
                            [_vm._v(_vm._s(_vm.order.buyer_user.email))]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "admin-order-card-label" }, [
                          _vm._v("Corporate Address:"),
                        ]),
                        _vm._v(" "),
                        _vm.buyerLicenseAddress.first
                          ? _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.buyerLicenseAddress.first) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.buyerLicenseAddress.second
                          ? _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.buyerLicenseAddress.second) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "5", md: "6" } },
                [
                  _c("b-card", { staticClass: "admin-order-card" }, [
                    _c("div", { staticClass: "row q-col-gutter-md" }, [
                      _c(
                        "div",
                        { staticClass: "col-6 col-sm-6 col-xs-12" },
                        [
                          _c("div", { staticClass: "admin-order-card-title" }, [
                            _vm._v("Order"),
                          ]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.order.id))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row q-col-gutter-md" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _c(
                                "div",
                                { staticClass: "admin-order-card-label mt-2" },
                                [_vm._v("Order Type:")]
                              ),
                              _vm._v(" "),
                              _vm.order.seller_license.type.is_recreational
                                ? _c("div", [_vm._v("Recreational")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.seller_license.type.is_medical
                                ? _c("div", [_vm._v("Medical")])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.order.fee_total
                              ? _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row",
                                      staticStyle: {
                                        "align-items": "flex-end",
                                        "flex-wrap": "nowrap",
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "admin-order-card-label mt-2",
                                          },
                                          [_vm._v("Order Fees:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mr-2" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedPrice(
                                                      _vm.order.fee_total
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "admin-order-fee-payment-status",
                                              {
                                                staticClass: "text-uppercase",
                                                attrs: { order: _vm.order },
                                              }
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.order.line_fees.length
                                        ? _c(
                                            "div",
                                            [
                                              _c("b-icon-info-circle-fill", {
                                                staticClass: "mx-2",
                                                staticStyle: {
                                                  width: "26px",
                                                  height: "26px",
                                                },
                                                attrs: {
                                                  id: "fees-info-icon",
                                                  variant: "primary",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "b-tooltip",
                                                {
                                                  attrs: {
                                                    target: "fees-info-icon",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "px-2 py-2 mb-0",
                                                      staticStyle: {
                                                        "list-style-type":
                                                          "none",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.order.line_fees,
                                                      function (fee, key) {
                                                        return _c(
                                                          "li",
                                                          { key: key },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  fee.name
                                                                ) +
                                                                ": " +
                                                                _vm._s(
                                                                  fee.value
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "admin-order-card-label mt-2" },
                            [_vm._v("Order Created:")]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.convertFromUtc(
                                  _vm.order.created_at,
                                  "M/D/YY h:mm a"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "admin-order-card-label mt-2" },
                            [_vm._v("Customer:")]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.order.buyer_license.facility.name)
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.order.notes
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "admin-order-card-label mt-2",
                                    staticStyle: { "margin-bottom": "6px" },
                                  },
                                  [_c("div", [_vm._v("Note to Buyer:")])]
                                ),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(_vm.order.notes))]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-6 col-sm-6 col-xs-12" },
                        [
                          _c(
                            "div",
                            { staticClass: "admin-order-card-label mt-2" },
                            [_vm._v("Payment Terms:")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.order.payment_terms, function (pt, index) {
                            return _c(
                              "b-badge",
                              {
                                key: index,
                                staticClass: "mr-2 mt-2",
                                attrs: {
                                  variant: pt.pivot.is_selected
                                    ? "success"
                                    : "secondary",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(pt.name) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "row q-col-gutter-md" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _c(
                                "div",
                                { staticClass: "admin-order-card-label mt-2" },
                                [_vm._v("Payment Due Date:")]
                              ),
                              _vm._v(" "),
                              _c("div", [_c("u", [_vm._v("To be Added")])]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "admin-order-card-label mt-2" },
                                [_vm._v("Payable to:")]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.order.seller_license.facility.name)
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.sellerLicenseAddress.first
                                ? _c("div", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.sellerLicenseAddress.first) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sellerLicenseAddress.second
                                ? _c("div", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.sellerLicenseAddress.second
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _c(
                                "div",
                                { staticClass: "admin-order-card-label mt-2" },
                                [_vm._v("Amount Due:")]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getFormattedPrice(_vm.order.price_total)
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "admin-order-card-label mt-2" },
                                [_vm._v("Payment Status:")]
                              ),
                              _vm._v(" "),
                              _c("div", [_c("u", [_vm._v("To be Added")])]),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { size: "12" } }, [
                _vm.hasAcceptedItems
                  ? _c(
                      "div",
                      { staticClass: "my-3 order-items-table-accepted py-2" },
                      _vm._l(_vm.order.items, function (orderItem, index) {
                        return _c("div", { key: index }, [
                          orderItem.is_accepted
                            ? _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "row no-wrap" },
                                  [
                                    _c("admin-order-item-row", {
                                      attrs: {
                                        order: _vm.order,
                                        item: orderItem,
                                        index: index,
                                        accepted: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPendingOrDeclinedItems
                  ? _c(
                      "div",
                      { staticClass: "single-order-items mt-4" },
                      _vm._l(_vm.order.items, function (orderItem, index) {
                        return _c("div", { key: index }, [
                          !orderItem.is_accepted
                            ? _c(
                                "div",
                                { staticClass: "row no-wrap" },
                                [
                                  _c("admin-order-item-row", {
                                    attrs: {
                                      order: _vm.order,
                                      item: orderItem,
                                      index: orderItem.index,
                                      declined: orderItem.is_declined,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }